import React from 'react';
import packageJson from '../../../../../package.json';
import { EvolveIcon } from '../../assets/images/evolve-icon';

export const Footer = () => {
  const version = packageJson.version;
  return (
    <div
      data-testid="footer"
      className="flex items-center justify-between px-2 h-10 bg-evolve-highlight"
    >
      <div></div>
      <EvolveIcon className="w-auto h-6" />
      <div className="text-white text-sm">Version - {version}</div>
    </div>
  );
};
